"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { ChangeEvent, KeyboardEvent, MouseEvent, useEffect, useRef, useState } from "react";
const EXAMPLE_QUERIES = ["limpieza de oficinas madrid", "servicios de consultoria tecnologica", "construccion de carreteras", "suministro de uniformes", "mantenimiento de infraestructuras", "servicios de seguridad"];
interface SearchInputBaseProps {
  readonly initialValue?: string;
  readonly handleChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  readonly handleKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  readonly handleClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  readonly disabled?: boolean;
  readonly className?: string;
}
export default function SearchInputBase(t0) {
  const $ = _c(19);
  const {
    initialValue: t1,
    handleChange,
    handleKeyDown,
    handleClick,
    disabled: t2,
    className: t3
  } = t0;
  const initialValue = t1 === undefined ? "" : t1;
  const disabled = t2 === undefined ? false : t2;
  const className = t3 === undefined ? "" : t3;
  const [displayedText, setDisplayedText] = useState("");
  const [inputValue, setInputValue] = useState(initialValue);
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      queryIndex: 0,
      charIndex: 0,
      isDeleting: false
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const stateRef = useRef(t4);
  let t5;
  if ($[1] !== handleChange) {
    t5 = e => {
      setInputValue(e.target.value);
      handleChange?.(e);
    };
    $[1] = handleChange;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const handleInputChange = t5;
  let t6;
  let t7;
  if ($[3] !== inputValue) {
    t6 = () => {
      if (inputValue !== "") {
        return;
      }
      const state = stateRef.current;
      let timeoutId = null;
      const handleAnimation = () => {
        const currentQuery = EXAMPLE_QUERIES[state.queryIndex] ?? "";
        if (!state.isDeleting && state.charIndex < currentQuery.length) {
          state.charIndex = state.charIndex + 1;
          setDisplayedText(currentQuery.slice(0, state.charIndex));
          timeoutId = setTimeout(handleAnimation, 50);
        } else {
          if (state.isDeleting && state.charIndex > 0) {
            state.charIndex = state.charIndex - 1;
            setDisplayedText(currentQuery.slice(0, state.charIndex));
            timeoutId = setTimeout(handleAnimation, 30);
          } else {
            if (!state.isDeleting && state.charIndex === currentQuery.length) {
              timeoutId = setTimeout(() => {
                state.isDeleting = true;
                handleAnimation();
              }, 3000);
            } else {
              if (state.isDeleting && state.charIndex === 0) {
                timeoutId = setTimeout(() => {
                  state.queryIndex = (state.queryIndex + 1) % EXAMPLE_QUERIES.length;
                  state.isDeleting = false;
                  state.charIndex = 0;
                  setDisplayedText("");
                  handleAnimation();
                }, 500);
              }
            }
          }
        }
      };
      handleAnimation();
      return () => {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
      };
    };
    t7 = [inputValue];
    $[3] = inputValue;
    $[4] = t6;
    $[5] = t7;
  } else {
    t6 = $[4];
    t7 = $[5];
  }
  useEffect(t6, t7);
  const t8 = `relative flex-1 ${className}`;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Search />;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== disabled || $[8] !== handleClick) {
    t10 = <Button className="text-muted-foreground absolute top-1/2 left-2 size-7 -translate-y-1/2 rounded-full" size="icon" variant="ghost" onClick={handleClick} disabled={disabled} type="button" aria-label="Buscar" name="search-button">{t9}</Button>;
    $[7] = disabled;
    $[8] = handleClick;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== displayedText || $[11] !== handleInputChange || $[12] !== handleKeyDown || $[13] !== inputValue) {
    t11 = <Input className="h-12 pr-4 pl-10 text-ellipsis" value={inputValue} onChange={handleInputChange} onKeyDown={handleKeyDown} placeholder={displayedText} type="search" aria-label={"Introducir t\xE9rmino de b\xFAsqueda"} name="search-input" />;
    $[10] = displayedText;
    $[11] = handleInputChange;
    $[12] = handleKeyDown;
    $[13] = inputValue;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t10 || $[16] !== t11 || $[17] !== t8) {
    t12 = <div className={t8}>{t10}{t11}</div>;
    $[15] = t10;
    $[16] = t11;
    $[17] = t8;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
}